<template>
  <!--
    HACK: If css is specified, no background is used. This is a
      workaround for MAUCH menus, where we have a checkbox next to a
      header.
  -->
  <div :class="[field.data.css ? '' : 'pt-1 px-3 overlay-options-field-bg']">
    <v-switch
      v-if="field.data.ui && field.data.ui === 'switch'"
      :input-value="value"
      :label="noLabel ? '' : field.data.label"
      :required="field.required"
      :style="field.data.css ? field.data.css.field : null"
      color="msr"
      class="darker-label"
      :hide-details="hideDetails"
      :disabled="disabled"
      data-cy="overlay-data-booleanfield"
      @change="onValueChanged"
    />
    <v-checkbox
      v-else
      :input-value="value"
      :label="noLabel ? '' : field.data.label"
      :placeholder="field.data.placeholder"
      :required="field.required"
      :style="field.data.css ? field.data.css.field : null"
      color="msr"
      class="darker-label"
      :hide-details="hideDetails"
      :disabled="disabled"
      data-cy="overlay-data-booleanfield"
      @change="onValueChanged"
    />
  </div>
</template>

<script>
import {OverlayOptionsField} from '@/mixins/overlayOptions.js';

export default {
  props: {
    field: {
      type: OverlayOptionsField,
      required: true,
    },
    value: {
      type: Boolean,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    noLabel: {
      type: Boolean,
      default: false,
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onValueChanged(value) {
      this.$emit('update:value', value);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/OverlayDataBooleanField.vue